import React from 'react'

import { Container, ContentHeader, Page } from 'components'
import { NcForm } from './components'

const NcNew = () => {
  return (
    <Page title="Criação de Não Conformidade (NC)">
      <Container maxWidth={false}>
        <ContentHeader title="Não Conformidade (NC)" />
        <NcForm />
      </Container>
    </Page>
  )
}

export default NcNew
